import { render, staticRenderFns } from "./Promotion_add_pos_price.vue?vue&type=template&id=29e250a2&scoped=true&"
import script from "./Promotion_add_pos_price.vue?vue&type=script&lang=js&"
export * from "./Promotion_add_pos_price.vue?vue&type=script&lang=js&"
import style0 from "./Promotion_add_pos_price.vue?vue&type=style&index=0&id=29e250a2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29e250a2",
  null
  
)

export default component.exports